export default {
    baseURL: "http://localhost:8080",
    gitURL: "https://api.github.com"
}